// extracted by mini-css-extract-plugin
module.exports = {"referrersContainer":"PatientDetailsReferrers_referrersContainer__1kg_V","loading":"PatientDetailsReferrers_loading__2wAMe"};